export const getMimeFileNames = (fileName: string[]) => {
  return fileName.map((name) => name.split('.').pop()?.toUpperCase() || '');
};

export const getFileSizeString = (bytes: number): string => {
  if (bytes >= 1000 * 1000) {
    const mb = bytes / (1000 * 1000);
    return `${Number.isInteger(mb) ? mb : mb.toFixed(2)}MB`;
  } else {
    const kb = bytes / 1000;
    return `${Number.isInteger(kb) ? kb : kb.toFixed(2)}KB`;
  }
};
